import { Divider, Text } from '@/components';
import { useTranslation } from 'react-i18next';

export const CommentDetailsUnreadDivider = () => {
  const { t } = useTranslation();
  return (
    <Divider plain style={{ borderColor: 'blue' }}>
      <Text
        variant="footnote"
        style={{ color: 'blue' }}
        text={t('comment.unread-below')}
      />
    </Divider>
  );
};
